/**
 * Per-request id for the `x-correlation-id` header that both API clients
 * (services/api.ts, stadiumCheckin/stationAxiosClient.ts) send. Besides
 * tracing, the API's cross-site write guard (assertSameSiteWrite in
 * api/src/middleware/auth.ts) requires it from browsers that send no
 * Sec-Fetch-Site.
 *
 * Not crypto.randomUUID() alone: it is missing before iOS 15.4 and outside
 * secure contexts, and a throw inside a request interceptor fails the request
 * with no status, which the scan retry policy reads as "offline" and queues.
 * The value only has to be present, not globally unique.
 */
export function correlationId(): string {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  } catch {
    // fall through to the fallback
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
}
